import React from "react";

import { Icon, congratulations } from "Icons/index";
import Button from "Components/button/Button";

import cx from "classnames";
import s from "./congratulations.scss";

export default class Congratulations extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      illustration,
      title,
      body,
      buttonText,
      buttonAction,
      hideButton,
      hideBody
    } = this.props;

    return (
      <div className={s.congratulation}>
        <Icon
          className={s.illustration}
          svg={illustration ? illustration : congratulations}
          width="10rem"
          height="10rem"
        />

        <div className={cx("sectionTitle", s.title)}>{title}</div>

        {!hideBody && <div className={s.text}>{React.cloneElement(body)}</div>}

        <div className={s.btn}>
          {!hideButton && (
            <Button color="accent" onClick={buttonAction}>
              {buttonText}
            </Button>
          )}
        </div>
      </div>
    );
  }
}
